import React from 'react'
import Image from 'next/image'
import AppImage from '../components/appImage.png'
import GooglePlay from '../components/google_play.png'
import Logo from '../components/logo.png'
import FeatureImage from '../components/FeatureImage'
import styled from 'styled-components'
import Link from 'next/link'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import {
  faObjectUngroup,
  faImages,
  faEyeSlash,
  faCalendarAlt,
  faSmileBeam,
  faPlusSquare,
} from '@fortawesome/free-regular-svg-icons'
import { Navbar, Nav, Container, Row, Col, Jumbotron } from 'react-bootstrap'
import Footer from '../components/Footer'

const Separator = styled.div`
  width: 100%;
  background: #ff7eb8;
  height: 1px;
  margin: 20px 0px;
`

const Home = () => (
  <div>
    <Navbar bg="light" expand="lg">
      <Navbar.Brand href="/">
        <Image src={Logo} height={48} alt="app logo" />
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="mr-auto">
          <Nav.Link href="/">Home</Nav.Link>
          <Nav.Link href="#features">Features</Nav.Link>
        </Nav>
        {/* <Link href="/privacy-policy">Privacy Policy</Link> */}
      </Navbar.Collapse>
    </Navbar>

    <Container className="mt-5">
      <Row>
        <Col>
          <Jumbotron>
            <p>THE FIRST ONE</p>
            <h1>My Perfect Diary</h1>
            <p>Your safe customizable place, check our features!</p>
            <Link href="https://play.google.com/store/apps/details?id=me.correria.correria">
              <Image src={GooglePlay} alt="google play logo" />
            </Link>
          </Jumbotron>
        </Col>
        <Col className="text-center">
          <FeatureImage style={{ width: 500, height: 500 }} />
        </Col>
      </Row>
    </Container>
    <Separator />
    <Container className="text-center">
      <h2 id="features">Features</h2>
      <p>Check out our awesome features!</p>
      <Row className="align-items-center">
        <Col>
          <Row className="align-items-center">
            <Col>
              <h3>Customizable</h3>
              <p>So you can focus on your history</p>
            </Col>
            <Col>
              <FontAwesomeIcon icon={faObjectUngroup} size="2x" color="#ff7eb8" />
            </Col>
          </Row>

          <Row className="align-items-center">
            <Col>
              <h3>Security</h3>
              <p>PIN or fingerprint unlock</p>
            </Col>
            <Col>
              <FontAwesomeIcon icon={faEyeSlash} size="2x" color="#ff7eb8" />
            </Col>
          </Row>

          <Row className="align-items-center">
            <Col>
              <h3>Mood control</h3>
              <p>Register and check statistics about your mood</p>
            </Col>
            <Col>
              <FontAwesomeIcon icon={faSmileBeam} size="2x" color="#ff7eb8" />
            </Col>
          </Row>
        </Col>

        <Col>
          <Image src={AppImage} height={500} alt="app" />
        </Col>

        <Col>
          <Row className="align-items-center">
            <Col>
              <FontAwesomeIcon icon={faCalendarAlt} size="2x" color="#ff7eb8" />
            </Col>
            <Col>
              <h3>Your timeline</h3>
              <p>All your histories in one place</p>
            </Col>
          </Row>

          <Row className="align-items-center">
            <Col>
              <FontAwesomeIcon icon={faImages} size="2x" color="#ff7eb8" />
            </Col>
            <Col>
              <h3>Gallery</h3>
              <p>Check the photos of all your histories in one place</p>
            </Col>
          </Row>

          <Row className="align-items-center">
            <Col>
              <FontAwesomeIcon icon={faPlusSquare} size="2x" color="#ff7eb8" />
            </Col>
            <Col>
              <h3>Much more</h3>
              <p>Dark mode, reminders, and many more</p>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>

    <Separator />
    <Footer></Footer>
  </div>
)

export default Home
